import CommonAction from '../../shared/Http/Http';
import {LOGS_GET,LOGS_GET_LAST} from '../constants';

export const getLogs = body => CommonAction('POST', null, `backoffice/admin/logs/get`, LOGS_GET, body);
export const getLogsLast = body => CommonAction('POST', null, `backoffice/admin/logs/get`, LOGS_GET_LAST, body);